import { Box, VStack } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { PUBLIC_PAGE_CONTENT_PT } from '@/components/Navbar/siteNavLayout';
import { PAGE_MAX_W } from '@/theme/sitePageTypography';

/** Wider max width when the standings chart sits beside the leaderboard on desktop. */
export const LEAGUE_PAGE_WIDE_MAX_W = 'min(1280px, 100%)';

export function LeaguePageLayout(props: { children: ReactNode; wide?: boolean }) {
  const maxW = props.wide ? LEAGUE_PAGE_WIDE_MAX_W : PAGE_MAX_W;
  return (
    <Box as='main' width='full' pb={10}>
      <Box maxW={maxW} mx='auto' px={{ base: 4, md: 8, xl: 12 }} pt={PUBLIC_PAGE_CONTENT_PT}>
        <VStack align='stretch' spacing={4} w='full'>
          {props.children}
        </VStack>
      </Box>
    </Box>
  );
}
